module.exports = __webpack_public_path__ + "img/bar_bg.7b5e44ce.jpg";